<template>
  <v-select
    id="solution-select"
    v-model="filter.municipioTarefa"
    item-text="nome"
    item-value="municipioTarefaId"
    :items="itens"
    label="Tarefa"
    clearable
    placeholder="Tarefa"
    :return-object="true"
    @change="change"
  >
    <template slot="no-data">
      Nenhuma Tarefa retornada
    </template>
  </v-select>
</template>

<script>
export default {
  name: "AppCityTaskCombobox",
  props: ["filter", "itens"],
  methods: {
    change(value) {
      if (value) this.filter.municipioTarefa = value;
      else this.filter.municipioTarefa = {};

      this.$emit("changeTask");
    }
  }
};
</script>
